// ALEX.ITEAMO.NET <<< =========================================================
export function ready(fn) {
    if (document.readyState != 'loading'){
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}
export function test() {
    let message: string = 'FROM HELPER!';
    console.log(message);
}
// =============================================================================